import lottie from "lottie-web";

document.addEventListener("DOMContentLoaded", () => {
  // Lotties de acordeón (con nombres "soluciones_01.json", etc.)
  const animationsMap = new Map();

  const els = document.querySelectorAll(".accordion__item-image.lottie");
  if (els) {
    els.forEach((el, i) => {
      const animation = lottie.loadAnimation({
        container: el,
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: `/themes/ikerfel-web/ui/assets/lotties/soluciones_0${i + 1}.json`,
      });

      animation.setSpeed(0.5);
      animationsMap.set(el, animation);
    });
  } 

  // Lógica del acordeón
  const buttons = document.querySelectorAll(".accordion__item-button");
  if (buttons) {
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const item = button.closest(".accordion__item");
  
        requestAnimationFrame(() => {
          if (item.classList.contains("expanded")) {
            const image = item.querySelector(".accordion__item-image.lottie");
            const anim = animationsMap.get(image);
            anim?.goToAndPlay(0, true);
          }
        });
      });
    });
  }  

  // 👇 Lottie adicional único con nombre propio
  const homeLottieEl = document.querySelector(".page-header-dark__image");
  if (homeLottieEl) {
    lottie.loadAnimation({
      container: homeLottieEl,
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: "/themes/ikerfel-web/ui/assets/lotties/home-logo.json",
    });
    // animation.setSpeed(3);
    //animationsMap.set(el, customLottieEl);
  }


  // 👇 Lottie adicional único con nombre propio
  const loaderWrap = document.querySelector("#loader--wrap");
  if (loaderWrap) {
    const siteWrapper = document.getElementById('site-wrapper');
    if (siteWrapper) {
      siteWrapper.style.opacity = 0;
    }
    const lenis = window.lenis; 
    // Pausar Lenis
    lenis?.stop();
    const animation = lottie.loadAnimation({
      container: loaderWrap,
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: "/themes/ikerfel-web/ui/assets/lotties/home-logo.json",
    });
    animation.setSpeed(2);
    //animationsMap.set(el, customLottieEl);

    animation.addEventListener("complete", () => {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          lenis?.start();
          if (siteWrapper) {
            siteWrapper.style.opacity = 1;
          }
          loaderWrap.classList.add('loaded');
          setTimeout(() => {
            loaderWrap.style.display = 'none';
          }, 300);
        });
      }
    });
  }
});
